

<ng-container *ngFor="let passenger of passengers; let i = index">
  <div class="passenger" id="passengerBox{{ i }}">
    <input type="checkbox" id="handle{{ i }}" [(ngModel)]="passenger.isOpen" />
    <div
      class="box is-paddingless "
      [class.is-box-start]="passengers.length > 1 && i === 0"
      [class.is-box-end]="passengers.length > 1 && i === passengers.length - 1"
      [class.is-box]="passengers.length > 1 && i !== passengers.length - 1 && i !== 0"
    >
      <div class="columns is-mobile is-centered is-marginless is-vcentered" (click)="expand($event, i)">
        <div class="passenger-title column is-11 is-vcentered d-inherit ">
          <app-checkbox
            label=" {{ passenger.passenger.firstName | lowercase }} {{
              passenger.passenger.lastName | lowercase
            }}"
            id="passenger{{ i }}"
            side="right"
            size="1em"
            [checkboxVisible]="false"
            labelVisible="false"
          ></app-checkbox>
          &nbsp;
          <span
            *ngIf="passenger.passenger.passengerType != 'adult'"
            class="tag is-light is-capitalized"
            >{{ 'shared.' +  passenger.passenger.passengerType | translate }}</span
          >
        </div>
        <div class="column is-1">
          <a class="arrow"></a>
        </div>
      </div>
      <div class="content">
        <div class="card-content  is-size-6">
          <ng-container *ngFor="let ticket of passenger.tickets; let j = index">
            <div class="ticket">
              <div class="columns is-size-6 is-6">
                <div class="column is-3">
                  <span class="is-uppercase">
                    {{
                      'itinerary-info.passengers-info.ticket-number' | translate
                    }}:
                    {{
                      ticket.number
                    }}
                  </span>
                </div>
                <div class="column is-2">
                  <span class="is-uppercase">
                    {{ 
                      'itinerary-info.passengers-info.emission-country' | translate
                    }}:
                    {{
                      ticket.issuerCountry
                    }}
                  </span>
                </div>
                <div class="column is-3">
                  <span class="is-uppercase">
                    {{
                      'itinerary-info.passengers-info.emission-date' | translate
                    }}:
                    {{
                      ticket.issuedDate | localizedDate
                    }}
                  </span>
                </div>
                <div class="column is-3" *ngIf="ticket.paymentRemark">
                  <span class="is-uppercase">
                    {{
                      'itinerary-info.passengers-info.paymentRemark' | translate
                    }}:
                    {{
                      ticket.paymentRemark
                    }}
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <div class="columns is-size-6 is-6">
                    <div class="column is-3" *ngIf="ticket.addCollect.amount != 0">
                      <span class="is-uppercase">
                        {{
                          'itinerary-info.passengers-info.addCollect' | translate
                        }}:
                        {{
                          ticket.addCollect.amount +  ticket.addCollect.currency
                        }}
                      </span>
                    </div>
                    <div class="column is-2" *ngIf="ticket.iataNumber">
                      <span class="is-uppercase">
                        {{
                          'itinerary-info.passengers-info.iata-number' | translate
                        }}:
                        {{
                          ticket.iataNumber
                        }}
                      </span>
                    </div>
                    <div class="column is-3" *ngIf="ticket.expirationDate | localizedDate">
                      <span class="is-uppercase">
                        {{
                          'itinerary-info.passengers-info.expiration-data' | translate
                        }}:
                        {{
                          ticket.expirationDate | localizedDate
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                
              </div>


              <div class="card-content  is-size-6">
                <app-ticket-segment [ticketSegments]="ticket.segments">
                </app-ticket-segment>
              </div>
            </div>
          </ng-container>

          
        </div>
      </div>
    </div>
  </div>
</ng-container>
